/* tslint:disable */

/**
 */
export class SizingResultEStimation {
    conso?: string;
    id?: number;
    viewEquip?: boolean;
    tr?: string;
    ts?: string;
    equipName?: string;
    toc?: string;
    dhpMax?: string;
    consoMax?: string;
    tocMax?: string;
    capabilitie?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/sizing-result-estimation.ts